<template>
  <div>
    <ul class="tab-list">
      <li v-for="tab in localizedTabs" :key="tab.id" :class="{ active: tab.id === activeTabId }" @click="activateTab(tab.id)">
        <span>{{ tab.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { inject, computed } from 'vue';

export default {
  setup() {
    const language = inject('language'); // Retrieve the current language
    const isEnglish = computed(() => language.value === 'en'); // Determine if the current language is English

    return {
      isEnglish,
    };
  },
  data() {
    return {
      tabs: [
        { id: 1, titleEn: 'Total declared emissions since 2022', titleSv: 'Deklarerade utsläpp totalt sedan 2022' },
        { id: 2, titleEn: 'Declared emissions per m² GFA', titleSv: 'Deklarerade utsläpp per m² BTA' },
      ],
      activeTabId: 1,
    };
  },
  computed: {
    localizedTabs() {
      return this.tabs.map((tab) => ({
        id: tab.id,
        title: this.isEnglish ? tab.titleEn : tab.titleSv,
      }));
    },
  },
  methods: {
    activateTab(tabId) {
      this.activeTabId = tabId;
      this.$emit('tabChanged', tabId);
    },
  },
};
</script>

<style scoped>
.tab-list {
  list-style: none;
  padding: 0px;
  margin: 0;
  display: flex;
  border-color: black;
}

.tab-list li {
  display: flex;
  justify-content: center;
  cursor: pointer;
  height: 80px;
  padding-top: 8px;
  background-color: transparent;
  align-items: center;
  text-align: center;
  border: 1px solid transparent;
  border-top-color: black;
  font-family: 'fet', sans-serif;
  width: 100%;
  padding: 20px;
}
.tab-list li span {
  color: black;
  font-family: 'fet', sans-serif;
  line-height: 1.2em;
  font-size: 13px;
}
.tab-list li.active {
  color: black;
}
.tab-list li:not(.active) {
  border-bottom: 1px solid black;
}
.tab-list li:not(.active) span {
  color: rgb(153, 153, 153);
}
.tab-list li:first-child.active {
  border-right-color: black;
}
.tab-list li:last-child {
  border-right-color: transparent;
}
.tab-list li:last-child.active {
  border-left-color: black;
}

@media all and (min-width: 1050px) {
  .tab-list li span {
    font-size: 17px;
  }
  /* .tab-list li:last-child {
    border-right-color: black;
  } */
  /*  .tab-list li:first-child {
    border-left-color: black;
  } */
}
</style>
